import { Button } from "@volca/ui/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@volca/ui/components/ui/dialog";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

/**
 * Confirms re-pushing an invoice whose bill is already live in QuickBooks,
 * which rewrites that bill. Held open while the push is in flight.
 */
export const QuickbooksBillUpdateDialog = ({
  open,
  onClose,
  onConfirm,
  isPending,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
}) => (
  <Dialog
    open={open}
    onOpenChange={(next) => {
      if (!next && !isPending) onClose();
    }}
  >
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Update the bill in QuickBooks?</DialogTitle>
        <DialogDescription className="sr-only">
          Confirm updating the bill in QuickBooks
        </DialogDescription>
      </DialogHeader>
      <Stack align="start" className="w-full" gap={4}>
        <Text tone="muted">
          The bill is rewritten from the invoice as it is now: its vendor,
          number, dates and lines.
        </Text>
        <Text tone="muted">
          If the bill was edited or paid in QuickBooks since Volca pushed it,
          the update is refused, so those changes are never overwritten.
        </Text>
      </Stack>
      <DialogFooter>
        <Button variant="secondary" onClick={onClose} disabled={isPending}>
          Cancel
        </Button>
        <Button onClick={onConfirm} disabled={isPending} loading={isPending}>
          Update bill
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
